import { render, staticRenderFns } from "./PrintLabel.vue?vue&type=template&id=2a45d53b&"
import script from "./PrintLabel.vue?vue&type=script&lang=js&"
export * from "./PrintLabel.vue?vue&type=script&lang=js&"
import style0 from "./PrintLabel.vue?vue&type=style&index=0&id=2a45d53b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports